import { render } from "./SignPadEditor.vue?vue&type=template&id=d0c38886&scoped=true&ts=true"
import script from "./SignPadEditor.vue?vue&type=script&lang=ts"
export * from "./SignPadEditor.vue?vue&type=script&lang=ts"

import "./SignPadEditor.vue?vue&type=style&index=0&id=d0c38886&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0c38886"]])

export default __exports__